import React, {useState, useEffect} from "react";
import {Container, TextField, Dialog, CircularProgress, Slide, Typography, Box} from "@material-ui/core";
import {MuiThemeProvider} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MUIDataTable from "mui-datatables";
import {datatableTheme} from "assets/css/datatable-theme.js";
import axios from "axios";
import Moment from "react-moment";
import CustomToolbar from "../../CustomToolbar";
import FilterComponent from "./Components/FilterComponent.js";
import {getCookie} from "../../components/auth/Helpers";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CabinetsReport = () => {
  const token = getCookie("token");
  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState([]); //table items
  const [columns, setColumns] = useState([]); //for modal2
  const [filterDialog, setFilterDialog] = useState(false);
  const [pagingInfo, setPagingInfo] = useState({page: 0, limit: 20, skip: 0, count: 20}); //Pagination Info
  const [searchEntry, setSearchEntry] = useState([]); //searchEntry

  const [cabinetDialog, setCabinetDialog] = useState(false);
  const [cabinetDialogData, setCabinetDialogData] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const openCabinetsDialog = async (city, doorType, status) => {
    setCabinetDialog(true);
    setSelectedCity(city);
    setSelectedType(doorType);
    setSelectedStatus(status);

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/filtered_cabinets`, {
      params: {city, door_type: doorType, status},
      headers: {Authorization: `Bearer ${token}`},
    });

    setCabinetDialogData(response.data);
  };

  const getFormattedDates = () => {
    const today = new Date();
    const formatDate = (date) => date.toISOString().split("T")[0];
    const currentDate = formatDate(today);
    const lastMonth = new Date(today);
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    const oneMonthBefore = formatDate(lastMonth);

    return {currentDate, oneMonthBefore};
  };

  const {currentDate, oneMonthBefore} = getFormattedDates();

  const [formFilterValues, setFormFilterValues] = useState({
    client: "",
    fridgesType: "",
    operationType: "",
    status: "",
    fromDate: oneMonthBefore,
    toDate: currentDate,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await axios(`${process.env.REACT_APP_BASE_URL}/reports/cabinets-by-city`, {
          responseType: "json",
          headers: {Authorization: `Bearer ${token}`},
        });

        if (response.data.success) {
          // Transform the data for the table
          const tableData = transformDataForTable(response.data.data);
          setItems(tableData);
        } else {
          console.error("API returned error:", response.data.error);
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [searchEntry]);

  // Transform the API response to flat table data
  const transformDataForTable = (apiData) => {
    const tableData = [];

    apiData.forEach((cityData) => {
      // Add city header row
      tableData.push({
        isHeader: true,
        city: cityData.city,
        door_type: cityData.city, // This will show as "City / Door Type"
        Operational: "",
        Quarantine: "",
        "Major Maintenance": "",
        Damaged: "",
        Discontinued: "",
        total: "",
      });

      // Add rows for each door type
      cityData.rows.forEach((row) => {
        if (row.type === "data") {
          const operational = row.Operational || 0;
          const quarantine = row.Quarantine || 0;
          const Damaged = row.Damaged || 0;
          const Discontinued = row.Discontinued || 0;
          const Major_Maintenance = row["Major Maintenance"] || 0;
          const total = operational + quarantine + Damaged + Discontinued + Major_Maintenance;

          tableData.push({
            isHeader: false,
            city: cityData.city,
            door_type: row.door_type,
            Operational: operational,
            Quarantine: quarantine,
            Damaged: Damaged,
            Discontinued: Discontinued,
            "Major Maintenance": Major_Maintenance,
            total: total,
          });
        }
      });
    });

    return tableData;
  };

  useEffect(() => {
    setColumns([
      {
        name: "city",
        options: {
          display: false, // Hide city column as it's used in grouping
        },
      },
      {
        name: "door_type",
        label: "City / Door Type",
        options: {
          customBodyRender: (value, tableMeta) => {
            const rowData = items[tableMeta.rowIndex];

            if (rowData.isHeader) {
              return (
                <Typography variant="h6" style={{fontWeight: "bold", color: "#1976d2"}}>
                  {value}
                </Typography>
              );
            }

            return <Box style={{paddingLeft: 20}}>{value}</Box>;
          },
          setCellProps: (value, rowIndex) => {
            const rowData = items[rowIndex];
            return {
              style: {
                backgroundColor: rowData.isHeader ? "#e3f2fd" : "transparent",
                fontWeight: rowData.isHeader ? "bold" : "normal",
              },
            };
          },
        },
      },
      {
        name: "Operational",
        label: "Operational",
        options: {
          customBodyRender: (value, tableMeta) => {
            const rowData = items[tableMeta.rowIndex];

            if (rowData.isHeader) return "";

            return (
              <span
                style={{
                  cursor: "pointer",
                  color: "#1E88E5",
                  fontWeight: "bold",
                }}
                onClick={() => openCabinetsDialog(rowData.city, rowData.door_type, "Operational")}
              >
                {value}
              </span>
            );
          },
        },
      },
      {
        name: "Quarantine",
        label: "Quarantine",
        options: {
          customBodyRender: (value, tableMeta) => {
            const rowData = items[tableMeta.rowIndex];

            if (rowData.isHeader) return "";

            return (
              <span
                style={{
                  cursor: "pointer",
                  color: "#1E88E5",
                  fontWeight: "bold",
                }}
                onClick={() => openCabinetsDialog(rowData.city, rowData.door_type, "Quarantine")}
              >
                {value}
              </span>
            );
          },
        },
      },
      {
        name: "Maintenance",
        label: "Maintenance",
        options: {
          customBodyRender: (value, tableMeta) => {
            const rowData = items[tableMeta.rowIndex];

            if (rowData.isHeader) return "";

            return (
              <span
                style={{
                  cursor: "pointer",
                  color: "#1E88E5",
                  fontWeight: "bold",
                }}
                onClick={() => openCabinetsDialog(rowData.city, rowData.door_type, "Maintenance")}
              >
                {value}
              </span>
            );
          },
        },
      },
      {
        name: "OutOfService",
        label: "Out of Service",
        options: {
          customBodyRender: (value, tableMeta) => {
            const rowData = items[tableMeta.rowIndex];

            if (rowData.isHeader) return "";

            return (
              <span
                style={{
                  cursor: "pointer",
                  color: "#1E88E5",
                  fontWeight: "bold",
                }}
                onClick={() => openCabinetsDialog(rowData.city, rowData.door_type, "Out of Service")}
              >
                {value}
              </span>
            );
          },
        },
      },
      {
        name: "total",
        label: "Total",
        options: {
          customBodyRender: (value, tableMeta) => {
            const rowData = items[tableMeta.rowIndex];

            if (rowData.isHeader) return "";

            return <span style={{fontWeight: "bold"}}>{value}</span>;
          },
        },
      },
    ]);
  }, [items]);

  const options = {
    selectableRows: "none",
    filter: false,
    onRowsDelete: null,
    rowsPerPage: pagingInfo.limit,
    rowsPerPageOptions: [20, 50, 100],
    selectToolbarPlacement: "replace",
    serverSide: false, // Since we're handling data transformation locally
    setRowProps: (row, dataIndex, rowIndex) => {
      const rowData = items[rowIndex];

      if (rowData.isHeader) {
        return {
          style: {
            backgroundColor: "#e3f2fd",
            fontWeight: "bold",
            borderBottom: "2px solid #1976d2",
          },
        };
      } else {
        return {
          style: {
            backgroundColor: rowIndex % 2 === 0 ? "#fafafa" : "#ffffff",
          },
        };
      }
    },
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setPagingInfo({...pagingInfo, page: tableState.page, skip: tableState.page * pagingInfo.limit});
      } else if (action === "changeRowsPerPage") {
        setPagingInfo({...pagingInfo, limit: tableState.rowsPerPage});
      }
    },
    print: false,
    download: false,
    viewColumns: false,
  };

  const handleFilter = () => {
    setFilterDialog(true);
  };

  const handleChangeSearch = (e, newValue) => {
    setSearchEntry(newValue);
  };

  return (
    <>
      <Container maxWidth="xl">
        {!isLoading ? (
          <MuiThemeProvider theme={datatableTheme}>
            <MUIDataTable
              title="Cabinets Report by City and Door Type"
              data={items}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        ) : (
          <CircularProgress size={30} className="pageLoader" />
        )}
      </Container>

      {/*********************** FILTER start ****************************/}
      <Dialog
        onClose={() => setFilterDialog(false)}
        maxWidth={"xl"}
        fullWidth
        aria-labelledby="customized-dialog-title"
        open={filterDialog}
      >
        <FilterComponent
          formFilterValues={formFilterValues}
          setFormFilterValues={setFormFilterValues}
          setOpenDialog={setFilterDialog}
          setItems={setItems}
          setPagingInfo={setPagingInfo}
          pagingInfo={pagingInfo}
          daily={true}
        />
      </Dialog>

      <Dialog
        open={cabinetDialog}
        onClose={() => setCabinetDialog(false)}
        maxWidth="lg"
        fullWidth
        TransitionComponent={Transition}
      >
        <div style={{padding: 20}}>
          <h2>
            City: {selectedCity} | Type: {selectedType} | Status: {selectedStatus}
          </h2>

          {!cabinetDialogData.length ? (
            <p>No cabinets found.</p>
          ) : (
            <MUIDataTable
              title=""
              data={cabinetDialogData}
              columns={[
                {label: "Serial", name: "sn"},
                {label: "Condition", name: "condition"},
                {label: "Location", name: "location"},
                {
                  label: "Created",
                  name: "createdAt",
                  options: {
                    customBodyRender: (value) => <Moment format="YYYY-MM-DD">{value}</Moment>,
                  },
                },
              ]}
              options={{selectableRows: "none"}}
            />
          )}
        </div>
      </Dialog>
    </>
  );
};

export default CabinetsReport;
